export class ViewBlockPropertiesPvConstants {
    static PROPERTY_DETAILS_TAB = "Property details";
    static VALUATION_TAB = "Valuation";
    static SAVE_BUTTON_PLACEHOLDER = "Save";
    static SAVE_VALUATION_BLOCK_PROPERTIES = "valuation block properties";
    static PROPERTY_TYPE_LOOKUPS = "View block properties";
    static DELETE_VALUATION_BLOCK_PROPERTY = "View Application Location Pv";
    static SUBSCRIBE_TO_PROPERTY = "subscribeToProperty";
    static SG_CODE_LABEL = "SG code";
    static DESCRIPTION_LABEL = "Description";
    static ADDRESS_LABEL = "Address";
    static ERF_NUMBER_LABEL = "Erf number";
    static FARM_NUMBER_LABEL = "Farm number";
    static UNIT_NUMBER_LABEL = "Unit number";
    static ERF_SIZE_LABEL = "Erf size";
    static IMPROVEMENT_LABEL = "Improvement";
    static SELECTED = "selected";
    static ERF_SIZE = "erfSize";
    static APPEAL_ID = "appealId";
    static OBJECTION_ID = "objectionId";
    static ZONING = "zoning";
    static VALUE = "value";
    static SUBDIVISION = "subdivision";
    static IMPROVEMENT = "improvement";
    static DESCRIPTION = "description";
    static UNIT_NUMBER = "unitNumber";
    static ERF_NUMBER = "erfNumber";
    static FARM_NUMBER = "farmNumber";
    static ADDRESS = "address";
    static SG_CODE = "sgcode";
    static PTNNUM = "PtnNum";
    static NO_ZONE_INFORMATION = "no zone information";
    static RECIPIENTS = "recipients";
    static OWNERS = "owners";
    static SUBDIVISION_ALTERNATE = "subdivision";
    static IMPROVEMENT_ALTERNATE = "Improvement";
    static DESCRIPTION_ALTERNATE = "Description";
    static UNIT_NUMBER_ALTERNATE = "UnitNumber";
    static ERF_NUMBER_ALTERNATE = "ErfNumber";
    static FARM_NUMBER_ALTERNATE = "FarmNumber";
    static ADDRESS_ALTERNATE = "Address";
    static SG_CODE_ALTERNATE = "Sgcode";
    static ERF_SIZE_ALTERNATE = "ErfSize";
    // public static readonly FARM_NUMBER_ALTERNATE = "FarmNumber";
    static SG_CODE_CONTROL_NAME = "sgCodeEdit";
    static DESCRIPTION_CONTROL_NAME = "descriptionEdit";
    static ADDRESS_CONTROL_NAME = "addressEdit";
    static ERF_NUMBER_CONTROL_NAME = "erfNumberEdit";
    static FARM_NUMBER_CONTROL_NAME = "farmNumberEdit";
    static UNIT_NUMBER_CONTROL_NAME = "unitNumberEdit";
    static ERF_SIZE_CONTROL_NAME = "erfSizeEdit";
    static IMPROVEMENT_CONTROL_NAME = "improvementEdit";
    static INVALID_SELECTION = "Invalid selection";
    static PLACEHOLDER_SELECT_VALUATION = "Select option";
    static SELECT_VALUATION_LABEL = "Select valuation";
    static OPEN_MARKET_VALUE_LABEL = "Open market value";
    static OPEN_MARKET_VALUE_CONTROL = "openMarketValue";
    static METHOD_LABEL = "Method";
    static STATUS_LABEL = "Status";
    static METHOD_CONTROL = "method";
    static STATUS_CONTROL = "status";
    static PROPERTY_DETAILS_FORM = "propertyDetailsForm";
    static VALUATION_FORM = "valuationForm";
    static SELECT_DATE_CONTROL = "selectDate";
    static IMPROVEMENT_VAL_CONTROL = "improvement";
    static CALCULATION_DATE_CONTROL = "calculationDate";
    static CALCULATION_DATE_LABEL = "Calculation date";
    static MULTIVALUES_CONTROL = "multiValues";
    static MULTIVALUES_LABEL = "Multi values";
    static INVALID_ZONING_ATTRIBUTE = "Zoning attribute is missing on the property zoning layer. Please contact your systems administrator.";
    static ZONING_NOT_FOUND = "The found zone ({0}) has not been configured in the lookups. Please contact your systems administrator.";
    static PROPERTIES_IN_BLOCK_LABEL = "Properties in block:";
    static Statuses = new Map()
        .set("Accepted block valuation", { status: "Accepted block valuation", color: "green" })
        .set("Accepted objection valuation", { status: "Accepted objection", color: "green" })
        .set("Accepted appeal valuation", { status: "Accepted appeal", color: "green" })
        .set("Rejected", { status: "Rejected", color: "red" })
        .set("Pending", { status: "Pending", color: "black" });
}
